import { render, staticRenderFns } from "./MobileSupportMenu.vue?vue&type=template&id=f4bb0a8a&scoped=true"
import script from "./MobileSupportMenu.vue?vue&type=script&lang=js"
export * from "./MobileSupportMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ec1e824a4fe600ca080e24d3f05cd390/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bb0a8a",
  null
  
)

export default component.exports